import type { FC, PropsWithChildren } from 'react';

import { Logo } from '../components';

export const DoctorAuthLayout: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="grid min-h-screen grid-rows-[62px_1fr] bg-brand-3">
      <header className="flex items-end justify-center">
        <Logo />
      </header>
      <div className="justfiy-center mt-[-62px] flex items-center">
        {children}
      </div>
    </div>
  );
};
